export function escapeRegExp(value: string) {
  return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

export function escapeXml(value: string) {
  return value.replace(/[<>&'\"]/g, (character) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", "'": "&apos;", '"': "&quot;" })[character] ?? character);
}

export function isExternalSource(url: string, currentOrigin?: string) {
  if (!/^https?:\/\//i.test(url)) return false;
  if (!currentOrigin) return true;
  try {
    return new URL(url).origin !== new URL(currentOrigin).origin;
  } catch {
    return true;
  }
}
